import type { SVGProps } from 'react';

const SvgMetadataTextArea = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H6C4.35 5 3 6.35 3 8v8c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3m1 11c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M10.21 8.65H7.55c-.14 0-.26.04-.36.13s-.16.22-.16.36.05.27.15.36.22.14.36.14h.79v2.99c0 .15.05.27.15.37s.23.15.38.15.29-.05.39-.15.16-.23.16-.37V9.64h.79c.14 0 .26-.04.36-.13s.16-.22.16-.36a.45.45 0 0 0-.16-.36.52.52 0 0 0-.36-.13z"
    />
  </svg>
);
export default SvgMetadataTextArea;
